import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Verifying...");
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");

    if (token) {
      fetch(`/api/users/verify_email?token=${token}`)
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setStatus("Email verified successfully! Redirecting...");
            setTimeout(() => {
              navigate("/");
            }, 2000); // 2秒後導回首頁
          } else {
            setStatus("Verification failed.");
          }
        })
        .catch(err => {
          setStatus("Verification error.");
          console.error(err);
        });
    } else {
      setStatus("No token found.");
    }
  }, [searchParams, navigate]);

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Email Verification</h2>
      <p>{status}</p>
    </div>
  );
};

export default VerifyEmail;
